import Vue from 'vue';
import VueSocialSharing from 'vue-social-sharing';

// Initialize VueSocialSharing and set custom sharing networks if specified
Vue.use(VueSocialSharing, [{"networks":{"facebookmessengers":"https:\u002F\u002Fwww.facebook.com\u002Fdialog\u002Fsend?link=@url&app_id=676524417346023&redirect_uri=https%3A%2F%2Fcving.com"}}][0]);
